<span matDialogTitle>{{ 'Salvataggio prospettiva' | siaTranslate }}</span>
<mat-dialog-content>
  @if (data.iscore) {
    <p>
      {{
        'La prospettiva CORE verrà sovrascritta con una di tipo CUSTOMER'
          | siaTranslate
      }}
    </p>
  } @else {
    <p>{{ 'La prospettiva verrà salvata come CUSTOMER' | siaTranslate }}</p>
  }
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="save()">Salva</button>
</mat-dialog-actions>
